import { Link } from "react-router-dom";

//redux
import { useAppDispatch, useAppSelector } from "../hooks/reduxHooks";
import { closeDrawer } from "../store/layout";

//material-ui
import { styled } from "@mui/system";

import { Drawer, DrawerProps, List, Divider, ListItem, ListItemIcon, ListItemText, IconButton, Badge } from "@mui/material";

//hooks
import { useSnacks } from "../providers/SnackProvider";

import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import HomeIcon from "@mui/icons-material/Home";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import AspectRatioIcon from "@mui/icons-material/AspectRatio";
import SettingsIcon from "@mui/icons-material/Settings";

export const drawerWidth = "100%";
export const drawerWidthMax = 360;

interface NavDrawerProps {
	applyUpdate: () => void;
}

const MainNavDrawer = styled(Drawer)<DrawerProps>(({ theme }) => ({
	display: "flex",
	width: drawerWidth,
	maxWidth: drawerWidthMax,
	flexShrink: 0,
	"& .MuiDrawer-paper": {
		width: drawerWidth,
		maxWidth: drawerWidthMax,
	},
	"& .MUIDrawer-header": {
		display: "flex",
		alignItems: "center",
		padding: theme.spacing(0, 1),
		// necessary for content to be below app bar
		//...theme.mixins.toolbar,
		justifyContent: "flex-end",
	},
	"& a": {
		textDecoration: "none",
		color: "inherit",
	},
}));

function NavDrawer(props: NavDrawerProps) {
	const { applyUpdate } = props;

	const dispatch = useAppDispatch();

	const updateAvailable = useAppSelector((state) => state.layout.updateAvailable);
	const drawerOpen = useAppSelector((state) => state.layout.drawerOpen);

	const [openSnack] = useSnacks();

	//navigation menu
	var navMenu = [
		{
			name: "Counters",
			path: "/",
			icon: <HomeIcon />,
		},
	];

	const toggleFullScreen = () => {
		var doc = window.document;
		var docEl = doc.documentElement;

		var requestFullScreen = docEl.requestFullscreen;
		var cancelFullScreen = doc.exitFullscreen;

		if (!doc.fullscreenElement) {
			requestFullScreen.call(docEl);
		} else {
			cancelFullScreen.call(doc);
		}
	};

	const doApplyUpdate = () => {
		if (navigator.onLine) {
			applyUpdate();
		} else {
			openSnack("Network Unavailable - internet required to update", "warn");
		}
	};

	return (
		<MainNavDrawer variant="persistent" anchor="left" open={drawerOpen}>
			<div>
				<IconButton onClick={() => dispatch(closeDrawer())} size="large">
					{drawerOpen ? <ChevronLeftIcon /> : <ChevronRightIcon />}
				</IconButton>
			</div>

			<Divider />

			<List>
				{navMenu.map(function (item, index) {
					return (
						<Link to={item.path} key={index} onClick={() => dispatch(closeDrawer())}>
							<ListItem key={index}>
								<ListItemIcon>{item.icon}</ListItemIcon>
								<ListItemText primary={item.name} />
							</ListItem>
						</Link>
					);
				})}
			</List>
			<Divider />
			<List>
				{updateAvailable ? (
					<ListItem key="Update" onClick={doApplyUpdate}>
						<ListItemIcon>
							<Badge color="error" variant="dot">
								<KeyboardArrowUpIcon />
							</Badge>
						</ListItemIcon>
						<ListItemText primary="Update App" />
					</ListItem>
				) : null}

				<Link to={"/settings"} onClick={() => dispatch(closeDrawer())}>
					<ListItem>
						<ListItemIcon>
							<SettingsIcon />
						</ListItemIcon>
						<ListItemText primary="Settings" />
					</ListItem>
				</Link>
			</List>
			<List>
				<ListItem key="fullscreeen" onClick={toggleFullScreen}>
					<ListItemIcon>
						<AspectRatioIcon />
					</ListItemIcon>
					<ListItemText primary="Full Screen" />
				</ListItem>
			</List>
		</MainNavDrawer>
	);
}

export default NavDrawer;
